import { createContext, useContext } from "react"

const notificationContext = {
    default: createContext(null)
}

export const createNotificationContext = (name) => {
    if(!Object.keys(notificationContext).includes(name)){
        notificationContext[name] = createContext(null);
        return notificationContext[name]
    } else {
        console.error("ERROR: Cannot reassign notification context")
    }
    return null
}

export const useNotification = (name) => {
    let context = notificationContext.default
    if(Object.keys(notificationContext).includes(name)){
        context = notificationContext[name]
    } else {
        console.error("ERROR: Unknown Notification Context - %s",name)
    }
    return useContext(context)
}